<section class="pre-content">
    <section class="ma__breadcrumbs ma__breadcrumbs--light">
        <nav class="ma__breadcrumbs__container">
            <ol class="ma__breadcrumbs__items">
                <li class="ma__breadcrumbs__item"><a href="#" aria-current="page">Recent Decisions</a></li>
            </ol>
        </nav>
    </section>
    <section class="ma__page-header">
        <div class="ma__page-header__content">
            <h2 class="ma__page-header__title">Recent Decisions</h2>
        </div>
    </section>
    <div class="main-content main-content--two">
        <h3 class="ma__comp-heading">Recent Certificates of the Secretary of Energy & Environmental Affairs
        </h3>
        <div class="monitor-date" id="project-list" style="margin-bottom: 30px;">
            <div class="main-content pubDate">
                <h4 style="padding-top:0; font-size:2rem" id="Certificates">Secretary certificates from {{dateFrom| date :'MMM d, y'}} through {{dateTo| date :'MMM d, y'}} </h4>
            </div>
        </div>
        <ul class="nav nav-tabs table-with-tabs statusTabs" role="tablist">
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="enfCert-tab" id="enfCert-tab" aria-selected="true" class="nav-link" [ngClass]="{'active show': tabIndex[0]}" data-toggle="tab" role="tab" (click)="LoadENFCert()" href="#dorCert">Environmental Notification Forms</a>
            </li>
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="new" id="visits-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[1]}" data-toggle="tab" role="tab" (click)="LoadEIRCert()" href="#dorCert">Environmental Impact Reports</a>
            </li>
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="review" id="review-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[2]}" data-toggle="tab" role="tab" (click)="LoadNPCCert()" href="#dorCert">Notices of Project Change</a>
            </li>
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="certificates" id="certificates-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[3]}" data-toggle="tab" role="tab" (click)="LoadRODCert()" href="#dorCert">Records of Decision</a>
            </li>
            <li class="nav-item" role="presentation"> <a aria-controls="advisoryRequest-tab" id="advisoryRequest-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[4]}" data-toggle="tab" role="tab" (click)="LoadSRPCert()" href="#dorCert">Special Review Procedures</a>
            </li>
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="publicNotices-tab" id="publicNotices-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[5]}" data-toggle="tab" role="tab" (click)="LoadPBNCert()" href="#dorCert">Public
                    Benefit Determinations</a>
            </li>
            <li class="nav-item" role="presentation" style="margin-bottom:5px">
                <a aria-controls="advisoryOpinions-tab" id="advisoryOpinions-tab" aria-selected="false" class="nav-link" [ngClass]="{'active show': tabIndex[6]}" data-toggle="tab" role="tab" (click)="LoadAOCert()" href="#dorCert">Advisory Opinions</a>
            </li>
        </ul>
        <div class="tab-content" style="border:none">
            <div aria-labelledby="Certificates" class="tab-pane fade in active show" id="dorCert" role="tabpanel">
                <div class="panel panel-primary">
                    <div class="panel-body">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover table-condensed">
                                <thead>
                                    <th scope="col">
                                        EEA No.&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col">
                                        Project Name&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col">
                                        Municipality&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col" style="width: 100px;">
                                        Document Type&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col" style="width: 125px;">
                                        Comments Due&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col">
                                        Action&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col" style="width: 125px;">
                                        Action Date&nbsp;<i class="fas fa-sort"></i>
                                    </th>
                                    <th scope="col" style="width: 59px;">Actions</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let certificate of recentDecisions">
                                        <td>{{certificate.eeaNumber}}</td>
                                        <td>
                                            <a class="table-link" (click)="OpenFirstAttachment(certificate)" (keyup.enter)="OpenFirstAttachment(certificate)" href="javascript:void(0);">
                                                {{certificate.projectName}}</a>
                                        </td>
                                        <td>{{certificate.municipalId}}</td>
                                        <td>{{certificate.type}}</td>
                                        <td>{{ValidateCommentsDue(certificate)}}</td>
                                        <td>{{certificate.action}}</td>
                                        <td>{{certificate.time| date :'MM/dd/yyyy'}}</td>
                                        <td>
                                            <button class="btn btn-default btn-xs" type="button" (click)="GoToSubmittal(certificate)" title="View document information.">
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    focusable="false" data-prefix="fas" data-icon="eye"
                                                    class="svg-inline--fa fa-eye fa-w-18" role="img"
                                                    viewBox="0 0 576 512" [attr.aria-labelledby]="certificate.eeaNumber">
                                                    <title [attr.id]="certificate.eeaNumber">View submittal</title>
                                                    <desc>Depicts an eye to open submittal information.</desc>
                                                    <path fill="currentColor"
                                                        d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z">
                                                    </path>
                                                </svg>&nbsp;View
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="mb-2">
                                <progressbar [value]="attachmentsBaseComponent.progressBarValue" *ngIf="attachmentsBaseComponent.showProgressBar">
                                    <span class="text-nowrap">Download in progress</span>
                                </progressbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div [hidden]="!isProgress" class="loading">Loading&#8230;</div>